module.exports = __webpack_public_path__ + "media/questions.877cdd22.mp3";